import RecipePreferences from './RecipePreferences';

export default RecipePreferences;
